// The brand name is "Freeezer" — three e's, not the common "freezer" spelling.
// The middle e of the "eee" is called out in a distinct color everywhere the
// wordmark appears, so the unusual spelling is unmistakable at a glance.
export function Wordmark({ className = '' }) {
  return (
    <span className={className}>
      Fre<span className="text-cyan-400">e</span>ezer
    </span>
  )
}
